import React, { } from 'react';

import {
  Skeleton,
} from '@mui/material';
import _ from 'lodash';

import CommitForm from '../../../../../components/CommitForm';
import ContentCard from '../../../../../components/ContentCard';
import { useUpdateStudentMutation } from '../../../../../services/students';
import { Student } from '../../../../../services/students/types';
import { Metadata } from '../../../../../services/types';
import useError from '../../../../../utils/react/hooks/useError';
import useSuccess from '../../../../../utils/react/hooks/useSuccess';

const BILLING_SETTINGS_FIELDS = {
  invoiceInstallmentCount: {
    xs: 12,
  },
};

interface BillingSettingsCardProps {
  student?: Student,
  studentMetadata?: Metadata,
}

const BillingSettingsCard = ({ student, studentMetadata } : BillingSettingsCardProps) => {
  const [updateStudent,
    { isLoading: isUpdateStudentLoading,
      isSuccess: isUpdateStudentSuccess,
      isError: isUpdateStudentError,
      error: updateStudentError }] = useUpdateStudentMutation();

  useSuccess(isUpdateStudentSuccess, 'Billing settings updated');
  useError(isUpdateStudentError, updateStudentError);

  if (!student) {
    return (
      <Skeleton variant="rectangular" height={64} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Billing Settings">
      <CommitForm
        data={_.pick(student, ['invoiceInstallmentCount'])}
        metadata={studentMetadata}
        fields={BILLING_SETTINGS_FIELDS}
        onSubmit={(changes) => updateStudent({
          studentId: student.id,
          newAttributes: changes,
        })}
        isSubmitLoading={isUpdateStudentLoading}
        autoSubmit
      />
    </ContentCard>
  );
};

export default BillingSettingsCard;
